export default "__VITE_ASSET__2abefe84__"